<section *ngIf="visible" class="user-products" aria-labelledby="user-products-heading">
  <div class="products-heading">
    <h2 id="user-products-heading">Products</h2>
    <button type="button" mat-stroked-button (click)="load()" [disabled]="state === 'loading'">{{state === 'error' ? 'Retry' : 'Reload records'}}</button>
  </div>
  <p class="products-note">Recorded Wallit state only. Live provider freshness and completeness are not checked. Reload reads saved records.</p>
  <p *ngIf="state === 'loading'" role="status">Loading products…</p>
  <p *ngIf="state === 'error'" role="alert">Unable to load products. Profile editing remains available. Try again.</p>
  <ng-container *ngIf="state === 'loaded'">
    <p *ngIf="products.length === 0">No recorded products or dependent-access products found.</p>
    <ng-container *ngFor="let product of currentProducts">
      <ng-container *ngTemplateOutlet="productCard; context: {$implicit: product}"></ng-container>
    </ng-container>
    <details *ngIf="terminatedProducts.length" class="terminated-products">
      <summary>Terminated products ({{terminatedProducts.length}})</summary>
      <ng-container *ngFor="let product of terminatedProducts">
        <ng-container *ngTemplateOutlet="productCard; context: {$implicit: product}"></ng-container>
      </ng-container>
    </details>
  </ng-container>
</section>

<ng-template #productCard let-product>
  <article class="product-card">
    <h3>{{product.vendorName || 'Unknown vendor'}} · {{product.productName || 'Unknown product'}}</h3>
    <p class="access-label">{{product.access === 'dependent' ? 'Dependent access · primary user owns this product' : 'Direct product'}}</p>
    <div class="product-status-grid">
      <div><strong>Enrollment</strong><p>{{enrollmentLabel(product)}}</p>
        <p *ngIf="product.enrollment.state === 'post'">{{product.enrollment.confirmed === true ? 'Confirmed by recorded evidence' : product.enrollment.confirmed === false ? 'Not confirmed by recorded evidence' : 'Confirmation unknown'}}</p>
        <p>Effective date: {{product.enrollment.effectiveDate || 'Unknown'}}<span *ngIf="product.enrollment.effectiveDate"> (recorded; does not establish current coverage)</span></p>
      </div>
      <div><strong>Billing</strong><p>{{billingLabel(product.billing.status)}}</p>
        <p>Subscription status: {{product.billing.subscriptionStatus || 'Unknown'}}</p>
        <p class="products-note">Billing status does not determine enrollment.</p>
      </div>
    </div>
    <p>Recorded plan: {{product.enrollment.plan || 'Unknown'}} · Coverage: {{coverageLabel(product.enrollment.coverage)}}</p>
    <p>Enrollment / termination record: {{product.enrollment.recordedAt ? (product.enrollment.recordedAt | date:'medium') : 'Unknown'}}</p>
    <div *ngIf="product.recentActivity.length" class="product-activity">
      <strong>Recent attempts and updates</strong>
      <p class="products-note">Activity since the latest enrollment or termination record. Outcomes are not inferred from attempts.</p>
      <ul><li *ngFor="let event of product.recentActivity">{{phaseLabel(event.phase)}} · {{event.recordedAt | date:'medium'}}<span *ngIf="event.plan"> · {{event.plan}}</span><span *ngIf="event.coverage"> · {{coverageLabel(event.coverage)}}</span></li></ul>
    </div>
    <details>
      <summary>Recorded dates and lifecycle history ({{product.history.length}})</summary>
      <p>Recorded enrollment refresh: {{product.enrollment.recordedRefreshAt ? (product.enrollment.recordedRefreshAt | date:'medium') : 'Unavailable'}}</p>
      <p>Latest lifecycle record: {{product.latestRecordAt | date:'medium'}}</p>
      <p>Billing snapshot timestamp: {{product.billing.snapshotTimestamp ? (product.billing.snapshotTimestamp | date:'medium') : 'Unavailable'}}</p>
      <p>Billing state timestamp: {{product.billing.stateTimestamp ? (product.billing.stateTimestamp | date:'medium') : 'Unavailable'}}</p>
      <p class="products-note">Stored billing timestamps may be fallback dates; they do not indicate a provider verification or sync.</p>
      <p *ngIf="product.billing.nextRetryAt">Next retry recorded: {{product.billing.nextRetryAt | date:'medium'}}</p>
      <p *ngIf="product.billing.cancelAt">Cancellation scheduled: {{product.billing.cancelAt | date:'medium'}}</p>
      <p *ngIf="product.billing.canceledAt">Billing cancelled: {{product.billing.canceledAt | date:'medium'}}</p>
      <ol class="product-history"><li *ngFor="let event of product.history">
        <strong>{{phaseLabel(event.phase)}}</strong> · {{event.recordedAt | date:'medium'}}
        <p>Record modified: {{event.modifiedAt ? (event.modifiedAt | date:'medium') : 'Unknown'}}</p>
        <p>Plan: {{event.plan || 'Unknown'}} · Coverage: {{coverageLabel(event.coverage)}} · Effective date: {{event.effectiveDate || 'Unknown'}}</p>
        <p>Billing: {{billingLabel(event.billing.status)}} · Subscription: {{event.billing.subscriptionStatus || 'Unknown'}}</p>
      </li></ol>
    </details>
  </article>
</ng-template>
